import { useContext, useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ajaxFuelCategories from "../../util/remote/ajaxFuelCategories";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxFuelPrices from "../../util/remote/ajaxFuelPrices";
import AuthContext from "../../Context/AuthContext";
const RegisterFuelPriceModal = ({ func }) => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  // Get current date in YYYY-MM-DD format
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [stationID, setStationID] = useState(station_idd);
  const [fuelCategoryID, setFuelCategoryID] = useState(null);
  const [sellingPrice, setSellingPrice] = useState("");
  const [date, setDate] = useState(getCurrentDate());
  const allRowsFilled = () =>
    stationID && fuelCategoryID && sellingPrice && date;
  // Submit handler
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const data = {
      station_id: stationID,
      fuel_id: fuelCategoryID,
      selling_price: sellingPrice,
      date: date,
      adjusted_by_id: userId,
    };
    setLoading(true);
    const response = await ajaxFuelPrices.create_Prices(data);
    setLoading(false);
    if (response.status === "OK") {
      func(); // refresh parent
      toast.success(response.message || "Fuel Price registered successfully");
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setStationID("1");
    setFuelCategoryID(null);
    setSellingPrice("");
    setDate(getCurrentDate());
  };
  // Fetch stations
  const [stationsList, setStationsList] = useState([]);
  const fetchStations = async () => {
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      setStationsList(
        Array.isArray(response.details) &&
          response.details.map((d) => ({
            value: Number(d.id),
            label: d.station_name,
          }))
      );
    } else {
      toast.error(response.message);
    }
  };
  // Fetch fuel categories
  const [fuelCategoriesList, setFuelCategoriesList] = useState([]);
  const fetchFuelCategories = async () => {
    const response = await ajaxFuelCategories.list_fuel_categories({
      station_id: stationID,
    });
    if (response.status === "OK") {
      setFuelCategoriesList(
        Array.isArray(response.details) &&
          response.details.map((d) => ({ value: d.id, label: d.fuel_category }))
      );
    } else {
      toast.error(response.message);
    }
  };
  useEffect(() => {
    fetchFuelCategories();
  }, [stationID]);
  useEffect(() => {
    fetchStations();
  }, []);

  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={handleAdd}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Register Fuel Price"}
      </button>
    </>
  );
  return (
    <SystemModal title="Register Fuel Price" size="md" footer={RenderFooter}>
      <Toaster />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Register Fuel Price</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Station */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Select Station <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={stationsList}
                        value={stationsList.find((s) => s.value === stationID)}
                        onChange={(selected) => setStationID(selected.value)}
                        isDisabled
                        placeholder="Select station"
                      />
                    </div>
                    {/* Fuel Category */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Fuel Category <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={fuelCategoriesList}
                        value={fuelCategoriesList.find(
                          (c) => c.value === fuelCategoryID
                        )}
                        onChange={(selected) =>
                          setFuelCategoryID(selected.value)
                        }
                        placeholder="Select fuel category"
                      />
                    </div>
                    {/* Selling Price */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Selling Price <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        value={sellingPrice}
                        onChange={(e) => setSellingPrice(e.target.value)}
                        className="form-control"
                        placeholder="Enter selling price"
                        required
                      />
                    </div>
                    {/* Date */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default RegisterFuelPriceModal;
